import React from 'react'
import styles from './commentItemFooter.module.css'
import { UserIcon } from '../../../../../../../../../Icons/userIcon';
import { ClockIcon } from '../../../../../../../../../Icons/clockIcon';
import { formatUTCDateTime } from '../../../../../../../../../../utils/formatUTCDate';
import { isTypeDraftComment } from '../../commentItem.utils'
import { CommentItemType } from '../../../../../../../../createEscalation.models';
import { Checkbox, CheckboxChangeEvent } from 'antd';
import { useInsights } from '../../../../../../../../../../Context/insightContext';

interface CommentItemFooterProps {
    type: CommentItemType;
    createdBy: string | null;
    createdAt: string | null;
    onCancel: () => void;
    onSave: () => Promise<void>;
    updateInEmailThread: boolean;
    setUpdateInEmailThread: (value: boolean) => void;
    isCommentEmailSend: boolean;
}

export const CommentItemFooter = (props: CommentItemFooterProps) => {
    const { type, createdBy, createdAt, onCancel, onSave, updateInEmailThread, setUpdateInEmailThread, isCommentEmailSend } = props;
    const {DRAFT_COMMENT, STATUS_CHANGED, COMMENT_ADDED} = CommentItemType;

    const { escalationDialogInfo } = useInsights();
    const isEmailSent = escalationDialogInfo?.escalationDetails?.isEmailSent;
    const isDraftComment = isTypeDraftComment(type);

    const handleUpdateInEmailThread = (e: CheckboxChangeEvent) => {
        if(!isDraftComment) return;
        setUpdateInEmailThread(e.target.checked); 
    }

    const checkboxValue = isDraftComment ? updateInEmailThread : (isCommentEmailSend);

    const supportedCheckboxTypes = new Set([DRAFT_COMMENT, STATUS_CHANGED, COMMENT_ADDED]);

    const renderCheckbox = isEmailSent && supportedCheckboxTypes.has(type);

    return <>
        {renderCheckbox &&
            <Checkbox
                checked={checkboxValue}
                onChange={handleUpdateInEmailThread}
                className={`${styles.checkboxText} ${isDraftComment ? '' : styles.checkboxTextReadOnly}`}
            >
                Update in Email Thread
            </Checkbox>}
        {isDraftComment ?
            <div className={styles.commentItemFooterButtonContainer}>
                <button className={styles.saveText} onClick={onSave}>Save</button>
                <button className={styles.cancelText} onClick={onCancel}>Cancel</button>
            </div> : (
                <div className={styles.commentItemFooterContainer}>
                    {createdBy && createdAt && (
                        <>
                            <div className={styles.createdByContainer}>
                                <UserIcon width={12} height={12} fillColor="#99A1AF" />
                                <p className={styles.commentItemFooterCreatedBy}>{createdBy}</p>
                            </div>
                            <p className={styles.commentItemFooterSeparator}>•</p>
                            <div className={styles.createdAtContainer}>
                                <ClockIcon width={12} height={12} fillColor="#99A1AF" />
                                <p className={styles.commentItemFooterCreatedAt}>{formatUTCDateTime(createdAt, false, true)}</p>
                            </div>
                        </>
                    )}
                </div>
            )
        }
    </>
}
